
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Divider, Pagination, Input } from "antd";

import CreateReport from './eachRepoert';

import "./transferCostDetail.scss";
class TransferCostDetail extends Component{
    constructor(props) {
        super(props)

        let ReportList=[
            {
                direction:'Azure to Wasabi',
                source: 'US-East-2',
                destination: 'US-East-1',
                size: '3GB',
                cost: '0.06',
                totalCost: '0.18',
            },
            {
                direction:'Generic S3 to Wasabi',
                source: 'US-East-1',
                destination: 'US-East-1',
                size: '6GB',
                cost: '0.04',
                totalCost: '0.24',
            },
            {
                direction:'AWS to Wasabi',
                source: 'US-East-2',
                destination: 'US-East-2',
                size: '7GB',
                cost: '0.05',
                totalCost: '0.35',
            },
            {
                direction:'AWS to Wasabi',
                source: 'US-East-2',
                destination: 'US-East-1',
                size: '5GB',
                cost: '0.04',
                totalCost: '0.2',
            },
            {
                direction:'AWS to Wasabi',
                source: 'US-East-1',
                destination: 'US-East-1',
                size: '2GB',
                cost: '0.02',
                totalCost: '0.04',
            },

        ];
        this.state = {
            ReportList: ReportList,
            search: '',
        };

    }

    updateSearch(event){
        this.setState({search: event.target.value.substr(0, 20)});
    }

    render(){
        const reportTableHeader = <ul>
                                    <li>Direction</li>
                                    <li>Source</li>
                                    <li>Destination</li>
                                    <li>Transfer Size</li>
                                    <li>GB Cost</li>
                                    <li>Total Cost</li>
                                </ul>
        
        let filterContacts = this.state.ReportList.filter(
            (contact) => {
                return contact.direction.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1;
            }
        );

        const TransferCostReportList = filterContacts.map((rl,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateReport 
                        key = {index}
                        direction = {rl.direction}
                        source = {rl.source}
                        destination = {rl.destination}
                        size = {rl.size}
                        cost = {rl.cost}
                        totalCost = {rl.totalCost}
                    />
                </div>
            )
        })
        return(
            <div className="transferCost-wrapper">
                <div className="header">
                    <h3>Transfer and Cost Report</h3>
                    {/* <Input 
                        className="search-input"
                        placeholder="Search Users or Account Name"
                        type="text"
                        value={this.state.search} 
                        onChange={this.updateSearch.bind(this)}
                        name="" 
                        id=""
                    /> */}

                    {/* <Input
                        className="search-input"
                        placeholder="Search ... "
                        // prefix={
                        //     (searchKeyword === '' || !visibleSearch) && (
                        //     <Icon type="search" />
                        //     )
                        // }
                        // suffix={
                        //     searchKeyword !== '' &&
                        //     visibleSearch && <Icon type={loading ? 'loading' : 'search'} />
                        // }
                        // value={searchKeyword}
                        onChange={this.onSearch}
                    /> */}
                </div>
                <div className="table-header">
                    {reportTableHeader}
                </div>
                <div>
                    {TransferCostReportList}
                </div>
                {/* <Divider/>
                <div className="page-pagination">
                    <Pagination size="small" total={500} defaultPageSize={10}/>

                </div> */}
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(TransferCostDetail)
  );